import { Component, useEffect, useRef, useState } from "react";
import { calculateRange, sliceData } from "./common-functions";

export const usePagination = ({
    dataProps: { data, page, rowsPerPage, emptyData, sort },
    rangeProps: { startIndex, endIndex }
}) => {
    const [dataRange, setDataRange] = useState({
        range: [],
        rangeSlice: []
    });
    const [slice, setSlice] = useState([]);
    useEffect(() => {
        const { range, rangeSlice } = calculateRange(data, rowsPerPage, startIndex, endIndex);
        setDataRange({ range: [...range], rangeSlice: [...rangeSlice] });

        const slice = sliceData(data, page, rowsPerPage, emptyData);
        setSlice([...slice]);
    }, [data, setDataRange, page, setSlice, startIndex, endIndex, sort]);

    return { slice, range: dataRange.range, rangeSlice: dataRange.rangeSlice };
};

export const useOutsideClick = (callback) => {
    const ref = useRef();

    useEffect(() => {
        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [ref]);

    return ref;
};

export class OutSideClickClass extends Component {
    handleClickOutside = (event) => {
        if (this.compRef && !this.compRef.contains(event.target)) {
            this.props.onClickOutside && this.props.onClickOutside();
        }
    };
    componentDidMount() {
        document.addEventListener("click", this.handleClickOutside, true);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.handleClickOutside, true);
    }
    render() {
        return <div ref={(el) => (this.compRef = el)}>{this.props.children}</div>;
    }
}
